/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive } from '@angular/core';
/**
 * Prefix to be placed the the front of the form field.
 */
export class MatPrefix {
}
MatPrefix.decorators = [
    { type: Directive, args: [{
                selector: '[matPrefix]',
            },] },
];
/**
 * @nocollapse
 */
MatPrefix.ctorParameters = () => [];
function MatPrefix_tsickle_Closure_declarations() {
    /** @type {?} */
    MatPrefix.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatPrefix.ctorParameters;
}
//# sourceMappingURL=prefix.js.map